// // import React, { useState, useEffect } from "react";
// // import { Modal, Button, Row, Col, Card } from "react-bootstrap";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import jsPDF from "jspdf";
// // import autoTable from "jspdf-autotable";
// // import { useUser } from "./context/UserContext";
// // import { getBaseUrl } from "../api";

// // const Payment = ({ show, handleClose }) => {
// //   const { loggedInUser, refreshPayments } = useUser();
// //   const Navigate = useNavigate();
// //   const [crn, setCrn] = useState(null);
// //   const baseUrl = getBaseUrl();

// //   useEffect(() => {
// //     axios.post(`https://${baseUrl}/request`, {
// //       object: "crn",
// //       qdn: "dial",
// //     }).then((response) => {
// //       if (response.data && response.data.crn) {
// //         setCrn(response.data.crn);
// //       }
// //     }).catch((error) => {
// //       console.error("CRN fetch error:", error);
// //     });
// //   }, []);

// //   useEffect(() => {
// //     const script = document.createElement("script");
// //     script.src = "https://checkout.razorpay.com/v1/checkout.js";
// //     script.async = true;
// //     script.onload = () => {
// //       console.log("Razorpay SDK loaded successfully.");
// //     };
// //     script.onerror = () => {
// //       console.error("Razorpay SDK failed to load.");
// //     };
// //     document.body.appendChild(script);
// //   }, []);
   
// //   const uploadPDF = (pdfBlob, fileName, yymm) => {
// //     return new Promise((resolve, reject) => {
// //       const xhr = new XMLHttpRequest();
// //       xhr.open("POST", `https://${baseUrl}/upload`, true);
// //       xhr.setRequestHeader("x-dt", yymm);
// //       xhr.setRequestHeader("x-name", fileName);
// //       xhr.setRequestHeader("x-enc", "bin");
// //       xhr.onload = () => {
// //         if (xhr.status === 200) resolve(xhr.responseText);
// //         else reject("Upload failed: " + xhr.statusText);
// //       };
// //       xhr.onerror = () => reject("Upload error");
// //       xhr.send(pdfBlob);
// //     });
// //   };

// //   const handlePayment = async (plan, amount) => {
// //     try {
// //       if (!window.Razorpay) {
// //         alert("Razorpay SDK failed to load. Please try again.");
// //         return;
// //       }

// //       if (!crn) {
// //         alert("Please enter a valid CRN.");
// //         return;
// //       }

// //       const today = new Date();
// //       // Current Timestamp
// //       const formattedDateTime = today.getFullYear() + "-" +
// //         String(today.getMonth() + 1).padStart(2, "0") + "-" +
// //         String(today.getDate()).padStart(2, "0") + " " +
// //         String(today.getHours()).padStart(2, "0") + ":" +
// //         String(today.getMinutes()).padStart(2, "0") + ":" +
// //         String(today.getSeconds()).padStart(2, "0");

// //       let expiryDate = new Date(today);
// //       let formattedExpiryDate = "";
      
// //       // LOGIC FIX: Do NOT extend time for Top-ups!
// //       if (plan === "1 Year Access") {
// //         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
// //         formattedExpiryDate = `${expiryDate.getFullYear()}-${String(expiryDate.getMonth() + 1).padStart(2, "0")}-${String(expiryDate.getDate()).padStart(2, "0")} ${String(expiryDate.getHours()).padStart(2, "0")}:${String(expiryDate.getMinutes()).padStart(2, "0")}:${String(expiryDate.getSeconds()).padStart(2, "0")}`;
// //       } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits") {
// //         // Inherit the existing expiry date from local storage
// //         const storedExpiry = localStorage.getItem("expiry_date");
// //         if (storedExpiry && storedExpiry !== "0") {
// //           formattedExpiryDate = storedExpiry;
// //         } else {
// //           // Fallback if they somehow buy topup without a base plan
// //           expiryDate.setFullYear(expiryDate.getFullYear() + 1);
// //           formattedExpiryDate = `${expiryDate.getFullYear()}-${String(expiryDate.getMonth() + 1).padStart(2, "0")}-${String(expiryDate.getDate()).padStart(2, "0")} ${String(expiryDate.getHours()).padStart(2, "0")}:${String(expiryDate.getMinutes()).padStart(2, "0")}:${String(expiryDate.getSeconds()).padStart(2, "0")}`;
// //         }
// //       }

// //       const user_id = localStorage.getItem("user_id");
// //       const email = localStorage.getItem("email");
// //       const user_name = localStorage.getItem("username");

// //       // Step 1: Create Razorpay Order
// //       const payload = {
// //         vendor: "Razorpay",
// //         amount: amount,
// //       };
// //       const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

// //       if (orderResponse.data.status !== "00") {
// //         alert("Couldn't process payment. Please try again.");
// //         return;
// //       }

// //       // Step 2: Open Razorpay Checkout
// //       const options = {
// //         key: orderResponse.data.apik,
// //         amount: amount,
// //         currency: "INR",
// //         name: "DiabWellness Private Limited",
// //         description: "Dial Decision Support Service",
// //         image: "https://diax.ai/assets/Group%203.png",
// //         order_id: orderResponse.data.details.id,
// //         handler: async (paymentResponse) => {
// //           try {
// //             // Step 3: Verify Signature
// //             const verifyPayload = {
// //               payment_id: paymentResponse.razorpay_payment_id,
// //               order_id: paymentResponse.razorpay_order_id,
// //               signature: paymentResponse.razorpay_signature,
// //             };

// //             const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

// //             if (verifyResponse.data.status !== "00") {
// //               alert("Payment verification failed. Please retry.");
// //               return;
// //             }

// //             // Step 4: Save Payment
// //             const paymentData = {
// //               action: "A",
// //               object: "payments",
// //               user_id: user_id,
// //               user_name: user_name,
// //               reason: "Dial Decision Support",
// //               crn: crn,
// //               order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
// //               status: "Success",
// //               details: JSON.stringify({
// //                 payment_info: verifyResponse.data,
// //                 hospital: "Dial",
// //                 plan: plan,
// //                 amount_paid: amount,
// //                 expiry_date: formattedExpiryDate,
// //                 order_date: formattedDateTime,
// //               }),
// //             };
// //             await axios.post(`https://${baseUrl}/request`, paymentData);

// //             await refreshPayments();

// //             localStorage.setItem("isSubscribed", "true");
// //             localStorage.setItem("amount_paid", amount);
// //             localStorage.setItem("expiry_date", formattedExpiryDate);
// //             localStorage.setItem("order_date", formattedDateTime);

// //             alert("Payment successful! Subscription/Topup is active.");

// //             // Step 5: Save Bill
// //             const billsave = {
// //               action: "A",
// //               object: "bill",
// //               bill_type: "Invoice",
// //               bill_class: "Dial Decision Support",
// //               user_id: user_id,
// //               user_name: user_name,
// //               total: amount,
// //               crn: parseInt(crn),
// //               bill_det: JSON.stringify({
// //                 Item: `Dial Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
// //                 amount: amount,
// //                 quantity: "1",
// //               }),
// //             };
// //             const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
// //             const bill_num = saveResponse.data.bill_num;
// //             console.log("bill",bill_num);
// //             if (!bill_num) throw new Error("Bill number not returned");

// //             // Step 6: Generate Invoice PDF
// //             const doc = new jsPDF();
// //             doc.setFontSize(22);
// //             doc.text("INVOICE", 80, 15);
// //             doc.setFontSize(12);
// //             doc.text(`Invoice No: ${bill_num}`, 14, 30);
// //             doc.text(`Date: ${formattedDateTime}`, 14, 40);
// //             doc.text(`User Name: ${user_name}`, 14, 50);
// //             doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
// //             doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

// //             const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
// //             const basePrice = amount / 1.18;
// //             const gstValue = amount - basePrice;
// //             const data = [[
// //               `Dial Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
// //               "1",
// //               `Rs.${basePrice.toFixed(2)}`,
// //               `Rs.${gstValue.toFixed(2)}`,
// //               `Rs.${amount.toFixed(2)}`,
// //             ]];

// //             autoTable(doc, {
// //               startY: 80,
// //               head: headers,
// //               body: data,
// //               theme: "grid",
// //               styles: { fontSize: 10, cellPadding: 3 },
// //               headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
// //               bodyStyles: { fontStyle: "bold" },
// //             });

// //             doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

// //             const pdfBlob = doc.output("blob");
// //             const nowmm = new Date().getMonth() + 1;
// //             const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
// //             const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

// //             await uploadPDF(pdfBlob, fileName, yymm);

// //             // Step 7: Upload to repos
// //             await axios.post(`https://${baseUrl}/request`, {
// //               action: "A",
// //               object: "repos",
// //               crn,
// //               user: user_id,
// //               rep_type: "Invoice",
// //               name: fileName,
// //               udt: today.toISOString().split("T")[0],
// //               mode: "Upload",
// //               internal_name: fileName,
// //               yyyymm: yymm,
// //               status: "N",
// //               last_update_user: user_id,
// //               external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
// //             });

// //             alert("Payment successful & Invoice uploaded!");
// //             Navigate("/invoice");
// //           } catch (error) {
// //             console.error("Error verifying payment:", error);
// //             alert("Payment verification failed. Please contact support.");
// //           }
// //         },
// //         prefill: {
// //           name: user_name,
// //           email: email,
// //           contact: user_id,
// //         },
// //         theme: {
// //           color: "#F37254",
// //         },
// //       };

// //       const rzp1 = new window.Razorpay(options);
// //       rzp1.open();
// //     } catch (error) {
// //       console.error("Error processing payment:", error);
// //       alert("An error occurred. Please try again.");
// //     }
// //   };

// //   return (
// //     <Modal show={show} onHide={handleClose} size="lg" centered>
// //       <Modal.Header closeButton>
// //         <Modal.Title>Select a Payment Plan</Modal.Title>
// //       </Modal.Header>
// //       <Modal.Body>
// //         <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
// //           Please subscribe or top-up your credits to continue using this feature.
// //         </p>
// //         <Row className="text-center">
// //           {/* 1 Year Access Plan */}
// //           <Col md={4} className="mb-3">
// //             <Card className="shadow p-3 h-100">
// //               <Card.Body className="d-flex flex-column">
// //                 <h5 className="text-primary">1 Year Access</h5>
// //                 <h3>₹5,999</h3>
// //                 <p>365 Days</p>
// //                 <p>100 calculations</p>
// //                 <div className="mt-auto">
// //                   <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
// //                     Proceed to Pay
// //                   </Button>
// //                 </div>
// //               </Card.Body>
// //             </Card>
// //           </Col>

// //           {/* Topup 50 Credits Plan */}
// //           <Col md={4} className="mb-3">
// //             <Card className="shadow p-3 h-100">
// //               <Card.Body className="d-flex flex-column">
// //                 <h5 className="text-info">Topup Plan</h5>
// //                 <h3>₹2,499</h3>
// //                 <p>50 Credits</p>
// //                 <p>Add 50 calculations to your account</p>
// //                 <div className="mt-auto">
// //                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
// //                     Proceed to Pay
// //                   </Button>
// //                 </div>
// //               </Card.Body>
// //             </Card>
// //           </Col>

// //           {/* Topup 100 Credits Plan */}
// //           <Col md={4} className="mb-3">
// //             <Card className="shadow p-3 h-100">
// //               <Card.Body className="d-flex flex-column">
// //                 <h5 className="text-danger">Topup Plan</h5>
// //                 <h3>₹4,499</h3>
// //                 <p>100 Credits</p>
// //                 <p>Add 100 calculations to your account</p>
// //                 <div className="mt-auto">
// //                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
// //                     Proceed to Pay
// //                   </Button>
// //                 </div>
// //               </Card.Body>
// //             </Card>
// //           </Col>
// //         </Row>
// //       </Modal.Body>
// //     </Modal>
// //   );
// // };

// // export default Payment;

// import React, { useState, useEffect } from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useUser } from "./context/UserContext";
// import { getBaseUrl } from "../api";

// const Payment = ({ show, handleClose }) => {
//   const { loggedInUser, refreshPayments } = useUser();
//   const Navigate = useNavigate();
//   const [crn, setCrn] = useState(null);
//   const baseUrl = getBaseUrl();

//   useEffect(() => {
//     axios.post(`https://${baseUrl}/request`, {
//       object: "crn",
//       qdn: "dial",
//     }).then((response) => {
//       if (response.data && response.data.crn) {
//         setCrn(response.data.crn);
//       }
//     }).catch((error) => {
//       console.error("CRN fetch error:", error);
//     });
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     script.onload = () => {
//       console.log("Razorpay SDK loaded successfully.");
//     };
//     script.onerror = () => {
//       console.error("Razorpay SDK failed to load.");
//     };
//     document.body.appendChild(script);
//   }, []);
   
//   const uploadPDF = (pdfBlob, fileName, yymm) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.open("POST", `https://${baseUrl}/upload`, true);
//       xhr.setRequestHeader("x-dt", yymm);
//       xhr.setRequestHeader("x-name", fileName);
//       xhr.setRequestHeader("x-enc", "bin");
//       xhr.onload = () => {
//         if (xhr.status === 200) resolve(xhr.responseText);
//         else reject("Upload failed: " + xhr.statusText);
//       };
//       xhr.onerror = () => reject("Upload error");
//       xhr.send(pdfBlob);
//     });
//   };

//   const handlePayment = async (plan, amount) => {
//     try {
//       if (!window.Razorpay) {
//         alert("Razorpay SDK failed to load. Please try again.");
//         return;
//       }

//       if (!crn) {
//         alert("Please enter a valid CRN.");
//         return;
//       }

//       const today = new Date();
//       // Current Timestamp
//       const formattedDateTime = today.getFullYear() + "-" +
//         String(today.getMonth() + 1).padStart(2, "0") + "-" +
//         String(today.getDate()).padStart(2, "0") + " " +
//         String(today.getHours()).padStart(2, "0") + ":" +
//         String(today.getMinutes()).padStart(2, "0") + ":" +
//         String(today.getSeconds()).padStart(2, "0");

//       let expiryDate = new Date(today);
//       let formattedExpiryDate = "";
      
//       // LOGIC FIX: Handle different plan types
//       if (plan === "1 Year Access") {
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//         formattedExpiryDate = `${expiryDate.getFullYear()}-${String(expiryDate.getMonth() + 1).padStart(2, "0")}-${String(expiryDate.getDate()).padStart(2, "0")} ${String(expiryDate.getHours()).padStart(2, "0")}:${String(expiryDate.getMinutes()).padStart(2, "0")}:${String(expiryDate.getSeconds()).padStart(2, "0")}`;
//       } else if (plan === "Testing Plan (5 Mins)") {
//         // Testing plan - only 5 minutes validity
//         expiryDate.setMinutes(expiryDate.getMinutes() + 5);
//         formattedExpiryDate = `${expiryDate.getFullYear()}-${String(expiryDate.getMonth() + 1).padStart(2, "0")}-${String(expiryDate.getDate()).padStart(2, "0")} ${String(expiryDate.getHours()).padStart(2, "0")}:${String(expiryDate.getMinutes()).padStart(2, "0")}:${String(expiryDate.getSeconds()).padStart(2, "0")}`;
//       } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits") {
//         // Inherit the existing expiry date from local storage
//         const storedExpiry = localStorage.getItem("expiry_date");
//         if (storedExpiry && storedExpiry !== "0") {
//           formattedExpiryDate = storedExpiry;
//         } else {
//           // Fallback if they somehow buy topup without a base plan
//           expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//           formattedExpiryDate = `${expiryDate.getFullYear()}-${String(expiryDate.getMonth() + 1).padStart(2, "0")}-${String(expiryDate.getDate()).padStart(2, "0")} ${String(expiryDate.getHours()).padStart(2, "0")}:${String(expiryDate.getMinutes()).padStart(2, "0")}:${String(expiryDate.getSeconds()).padStart(2, "0")}`;
//         }
//       }

//       const user_id = localStorage.getItem("user_id");
//       const email = localStorage.getItem("email");
//       const user_name = localStorage.getItem("username");

//       // Step 1: Create Razorpay Order
//       const payload = {
//         vendor: "Razorpay",
//         amount: amount,
//       };
//       const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

//       if (orderResponse.data.status !== "00") {
//         alert("Couldn't process payment. Please try again.");
//         return;
//       }

//       // Step 2: Open Razorpay Checkout
//       const options = {
//         key: orderResponse.data.apik,
//         amount: amount,
//         currency: "INR",
//         name: "DiabWellness Private Limited",
//         description: "Dial Decision Support Service",
//         image: "https://diax.ai/assets/Group%203.png",
//         order_id: orderResponse.data.details.id,
//         handler: async (paymentResponse) => {
//           try {
//             // Step 3: Verify Signature
//             const verifyPayload = {
//               payment_id: paymentResponse.razorpay_payment_id,
//               order_id: paymentResponse.razorpay_order_id,
//               signature: paymentResponse.razorpay_signature,
//             };

//             const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

//             if (verifyResponse.data.status !== "00") {
//               alert("Payment verification failed. Please retry.");
//               return;
//             }

//             // Step 4: Save Payment
//             const paymentData = {
//               action: "A",
//               object: "payments",
//               user_id: user_id,
//               user_name: user_name,
//               reason: "Dial Decision Support",
//               crn: crn,
//               order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
//               status: "Success",
//               details: JSON.stringify({
//                 payment_info: verifyResponse.data,
//                 hospital: "Dial",
//                 plan: plan,
//                 amount_paid: amount,
//                 expiry_date: formattedExpiryDate,
//                 order_date: formattedDateTime,
//               }),
//             };
//             await axios.post(`https://${baseUrl}/request`, paymentData);

//             await refreshPayments();

//             localStorage.setItem("isSubscribed", "true");
//             localStorage.setItem("amount_paid", amount);
//             localStorage.setItem("expiry_date", formattedExpiryDate);
//             localStorage.setItem("order_date", formattedDateTime);

//             // For testing plan, set a timeout to expire after 5 minutes
//             if (plan === "Testing Plan (5 Mins)") {
//               setTimeout(() => {
//                 localStorage.setItem("isSubscribed", "false");
//                 localStorage.setItem("expiry_timestamp", "0");
//                 alert("Your testing period has expired. Please purchase a subscription to continue.");
//                 window.location.reload();
//               }, 5 * 60 * 1000); // 5 minutes
//             }

//             alert("Payment successful! Subscription/Topup is active.");

//             // Step 5: Save Bill
//             const billsave = {
//               action: "A",
//               object: "bill",
//               bill_type: "Invoice",
//               bill_class: "Dial Decision Support",
//               user_id: user_id,
//               user_name: user_name,
//               total: amount,
//               crn: parseInt(crn),
//               bill_det: JSON.stringify({
//                 Item: `Dial Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//                 amount: amount,
//                 quantity: "1",
//               }),
//             };
//             const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
//             const bill_num = saveResponse.data.bill_num;
//             console.log("bill",bill_num);
//             if (!bill_num) throw new Error("Bill number not returned");

//             // Step 6: Generate Invoice PDF
//             const doc = new jsPDF();
//             doc.setFontSize(22);
//             doc.text("INVOICE", 80, 15);
//             doc.setFontSize(12);
//             doc.text(`Invoice No: ${bill_num}`, 14, 30);
//             doc.text(`Date: ${formattedDateTime}`, 14, 40);
//             doc.text(`User Name: ${user_name}`, 14, 50);
//             doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
//             doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

//             const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
//             const basePrice = amount / 1.18;
//             const gstValue = amount - basePrice;
//             const data = [[
//               `Dial Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//               "1",
//               `Rs.${basePrice.toFixed(2)}`,
//               `Rs.${gstValue.toFixed(2)}`,
//               `Rs.${amount.toFixed(2)}`,
//             ]];

//             autoTable(doc, {
//               startY: 80,
//               head: headers,
//               body: data,
//               theme: "grid",
//               styles: { fontSize: 10, cellPadding: 3 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
//               bodyStyles: { fontStyle: "bold" },
//             });

//             doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

//             const pdfBlob = doc.output("blob");
//             const nowmm = new Date().getMonth() + 1;
//             const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
//             const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

//             await uploadPDF(pdfBlob, fileName, yymm);

//             // Step 7: Upload to repos
//             await axios.post(`https://${baseUrl}/request`, {
//               action: "A",
//               object: "repos",
//               crn,
//               user: user_id,
//               rep_type: "Invoice",
//               name: fileName,
//               udt: today.toISOString().split("T")[0],
//               mode: "Upload",
//               internal_name: fileName,
//               yyyymm: yymm,
//               status: "N",
//               last_update_user: user_id,
//               external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
//             });

//             alert("Payment successful & Invoice uploaded!");
//             Navigate("/invoice");
//           } catch (error) {
//             console.error("Error verifying payment:", error);
//             alert("Payment verification failed. Please contact support.");
//           }
//         },
//         prefill: {
//           name: user_name,
//           email: email,
//           contact: user_id,
//         },
//         theme: {
//           color: "#F37254",
//         },
//       };

//       const rzp1 = new window.Razorpay(options);
//       rzp1.open();
//     } catch (error) {
//       console.error("Error processing payment:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Select a Payment Plan</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
//           Please subscribe or top-up your credits to continue using this feature.
//         </p>
//         <Row className="text-center">
//           {/* 1 Year Access Plan - Updated to 20 calculations */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-primary">1 Year Access</h5>
//                 <h3>₹5,999</h3>
//                 <p>365 Days Validity</p>
//                 <p className="text-warning fw-bold">20 Calculations Included</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Testing Plan - 5 Minutes Only */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100 border-warning">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-warning">🎯 Testing Plan</h5>
//                 <h3>₹99</h3>
//                 <p>5 Minutes Only</p>
//                 <p className="text-danger fw-bold">5 Calculations Included</p>
//                 <p className="small text-muted">Limited time access for testing purposes</p>
//                 <div className="mt-auto">
//                   <Button variant="warning" className="w-100 text-white" onClick={() => handlePayment("Testing Plan (5 Mins)", 99)}>
//                     Try Now - ₹99
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Topup 50 Credits Plan */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-info">Topup Plan</h5>
//                 <h3>₹2,499</h3>
//                 <p>50 Credits</p>
//                 <p>Add 50 calculations to your account</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Topup 100 Credits Plan */}
//           <Col md={4} className="mb-3 mt-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-danger">Topup Plan</h5>
//                 <h3>₹4,499</h3>
//                 <p>100 Credits</p>
//                 <p>Add 100 calculations to your account</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Payment;

// 15-05 10am
// import React, { useState, useEffect } from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useUser } from "./context/UserContext";
// import { getBaseUrl } from "../api";

// const Payment = ({ show, handleClose, onPaymentSuccess }) => {
//   const { loggedInUser, refreshPayments, userDetails } = useUser();
//   const Navigate = useNavigate();
//   const [crn, setCrn] = useState(null);
//   const baseUrl = getBaseUrl();

//   useEffect(() => {
//     axios.post(`https://${baseUrl}/request`, {
//       object: "crn",
//       qdn: "dial",
//     }).then((response) => {
//       if (response.data && response.data.crn) {
//         setCrn(response.data.crn);
//       }
//     }).catch((error) => {
//       console.error("CRN fetch error:", error);
//     });
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     script.onload = () => {
//       console.log("Razorpay SDK loaded successfully.");
//     };
//     script.onerror = () => {
//       console.error("Razorpay SDK failed to load.");
//     };
//     document.body.appendChild(script);
//   }, []);
   
//   const uploadPDF = (pdfBlob, fileName, yymm) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.open("POST", `https://${baseUrl}/upload`, true);
//       xhr.setRequestHeader("x-dt", yymm);
//       xhr.setRequestHeader("x-name", fileName);
//       xhr.setRequestHeader("x-enc", "bin");
//       xhr.onload = () => {
//         if (xhr.status === 200) resolve(xhr.responseText);
//         else reject("Upload failed: " + xhr.statusText);
//       };
//       xhr.onerror = () => reject("Upload error");
//       xhr.send(pdfBlob);
//     });
//   };

//   const getCurrentDialCount = () => {
//     const fromUserDetails = userDetails?.response?.[userDetails.response.length - 1]?.dial_cnt;
//     const fromUserLocal = localStorage.getItem(`dial_cnt_${loggedInUser}`);
//     const fromGenericLocal = localStorage.getItem("dial_cnt");

//     // IMPORTANT FIX:
//     // Use the maximum available dial count, not the first value.
//     // After trial, DB/userDetails may still be stale as 0 while localStorage has 2.
//     // If we save start_dial_cnt as 0, new top-up 50 shows 48.
//     // Saving start_dial_cnt as 2 makes new top-up 50 show full 50.
//     const candidates = [fromUserDetails, fromUserLocal, fromGenericLocal]
//       .map((value) => parseInt(value ?? "0", 10))
//       .filter((value) => Number.isFinite(value) && value >= 0);

//     return candidates.length ? Math.max(...candidates) : 0;
//   };

//   const handlePayment = async (plan, amount) => {
//     try {
//       if (!window.Razorpay) {
//         alert("Razorpay SDK failed to load. Please try again.");
//         return;
//       }

//       if (!crn) {
//         alert("Please enter a valid CRN.");
//         return;
//       }

//       const today = new Date();
//       // Current Timestamp
//       const formattedDateTime = today.getFullYear() + "-" +
//         String(today.getMonth() + 1).padStart(2, "0") + "-" +
//         String(today.getDate()).padStart(2, "0") + " " +
//         String(today.getHours()).padStart(2, "0") + ":" +
//         String(today.getMinutes()).padStart(2, "0") + ":" +
//         String(today.getSeconds()).padStart(2, "0");

//       let expiryDate = new Date(today);
//       let formattedExpiryDate = "";

//       const formatDateTime = (dateObj) => {
//         return dateObj.getFullYear() + "-" +
//           String(dateObj.getMonth() + 1).padStart(2, "0") + "-" +
//           String(dateObj.getDate()).padStart(2, "0") + " " +
//           String(dateObj.getHours()).padStart(2, "0") + ":" +
//           String(dateObj.getMinutes()).padStart(2, "0") + ":" +
//           String(dateObj.getSeconds()).padStart(2, "0");
//       };

//       const parseDateTimeToMs = (dateStr) => {
//         if (!dateStr) return 0;
//         const parts = dateStr.split(/[- :]/);
//         if (parts.length >= 6) {
//           return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//         }
//         if (parts.length === 3) {
//           return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime();
//         }
//         return 0;
//       };

//       // Plan validity logic
//       if (plan === "Testing Plan (2 Mins)") {
//         // Testing: 20 calculations, 2 minutes validity
//         expiryDate.setMinutes(expiryDate.getMinutes() + 2);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits") {
//         // Top-up rule:
//         // If existing subscription is still active, keep the same expiry.
//         // If subscription is already expired or missing, top-up itself gives fresh 1-year validity.
//         const storedExpiry = localStorage.getItem("expiry_date");
//         const storedExpiryMs = parseDateTimeToMs(storedExpiry);
//         const nowMs = today.getTime();

//         if (storedExpiry && storedExpiry !== "0" && storedExpiryMs > nowMs) {
//           formattedExpiryDate = storedExpiry;
//         } else {
//           expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//           formattedExpiryDate = formatDateTime(expiryDate);
//         }
//       } else {
//         // 1 Year Access / Premium: 1 year validity
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       }

//       const user_id = localStorage.getItem("user_id");
//       const email = localStorage.getItem("email");
//       const user_name = localStorage.getItem("username");

//       // Step 1: Create Razorpay Order
//       const payload = {
//         vendor: "Razorpay",
//         amount: amount,
//       };
//       const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

//       if (orderResponse.data.status !== "00") {
//         alert("Couldn't process payment. Please try again.");
//         return;
//       }

//       // Step 2: Open Razorpay Checkout
//       const options = {
//         key: orderResponse.data.apik,
//         amount: amount,
//         currency: "INR",
//         name: "DiabWellness Private Limited",
//         description: "Dial Decision Support Service",
//         image: "https://diax.ai/assets/Group%203.png",
//         order_id: orderResponse.data.details.id,
//         handler: async (paymentResponse) => {
//           try {
//             // Step 3: Verify Signature
//             const verifyPayload = {
//               payment_id: paymentResponse.razorpay_payment_id,
//               order_id: paymentResponse.razorpay_order_id,
//               signature: paymentResponse.razorpay_signature,
//             };

//             const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

//             if (verifyResponse.data.status !== "00") {
//               alert("Payment verification failed. Please retry.");
//               return;
//             }

//             // Step 4: Save Payment
//             // Read the latest used count only at successful payment time.
//             // This becomes the baseline for this new purchase.
//             const currentDialCountAtPurchase = getCurrentDialCount();

//             const paymentData = {
//               action: "A",
//               object: "payments",
//               user_id: user_id,
//               user_name: user_name,
//               reason: "Dial Decision Support",
//               crn: crn,
//               order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
//               status: "Success",
//               details: JSON.stringify({
//                 payment_info: verifyResponse.data,
//                 hospital: "Dial",
//                 plan: plan,
//                 amount_paid: amount,
//                 expiry_date: formattedExpiryDate,
//                 order_date: formattedDateTime,

//                 // Home.js will use this to calculate ONLY current active plan balance.
//                 // When old plan expires, old remaining balance will not carry over.
//                 start_dial_cnt: currentDialCountAtPurchase,
//                 usage_start_count: currentDialCountAtPurchase,
//                 dial_cnt_at_purchase: currentDialCountAtPurchase,
//               }),
//             };
//             await axios.post(`https://${baseUrl}/request`, paymentData);

//             await refreshPayments();

//             const formattedExpiryMs = parseDateTimeToMs(formattedExpiryDate);
//             localStorage.setItem("isSubscribed", "true");
//             localStorage.setItem("amount_paid", amount);
//             localStorage.setItem("expiry_date", formattedExpiryDate);
//             localStorage.setItem("expiry_timestamp", formattedExpiryMs.toString());
//             localStorage.setItem("order_date", formattedDateTime);
//             localStorage.setItem(`active_usage_baseline_${loggedInUser}`, currentDialCountAtPurchase.toString());

//             if (onPaymentSuccess) await onPaymentSuccess();

//             // Testing plan time validity is only for display.
//             // Do NOT force subscription false after 2 minutes if calculations remain.
//             // Home.js will continue allowing access until remaining balance becomes 0.

//             alert("Payment successful! Subscription/Topup is active.");

//             // Step 5: Save Bill
//             const billsave = {
//               action: "A",
//               object: "bill",
//               bill_type: "Invoice",
//               bill_class: "Dial Decision Support",
//               user_id: user_id,
//               user_name: user_name,
//               total: amount,
//               crn: parseInt(crn),
//               bill_det: JSON.stringify({
//                 Item: `Dial Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//                 amount: amount,
//                 quantity: "1",
//               }),
//             };
//             const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
//             const bill_num = saveResponse.data.bill_num;
//             console.log("bill",bill_num);
//             if (!bill_num) throw new Error("Bill number not returned");

//             // Step 6: Generate Invoice PDF
//             const doc = new jsPDF();
//             doc.setFontSize(22);
//             doc.text("INVOICE", 80, 15);
//             doc.setFontSize(12);
//             doc.text(`Invoice No: ${bill_num}`, 14, 30);
//             doc.text(`Date: ${formattedDateTime}`, 14, 40);
//             doc.text(`User Name: ${user_name}`, 14, 50);
//             doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
//             doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

//             const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
//             const basePrice = amount / 1.18;
//             const gstValue = amount - basePrice;
//             const data = [[
//               `Dial Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//               "1",
//               `Rs.${basePrice.toFixed(2)}`,
//               `Rs.${gstValue.toFixed(2)}`,
//               `Rs.${amount.toFixed(2)}`,
//             ]];

//             autoTable(doc, {
//               startY: 80,
//               head: headers,
//               body: data,
//               theme: "grid",
//               styles: { fontSize: 10, cellPadding: 3 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
//               bodyStyles: { fontStyle: "bold" },
//             });

//             doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

//             const pdfBlob = doc.output("blob");
//             const nowmm = new Date().getMonth() + 1;
//             const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
//             const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

//             await uploadPDF(pdfBlob, fileName, yymm);

//             // Step 7: Upload to repos
//             await axios.post(`https://${baseUrl}/request`, {
//               action: "A",
//               object: "repos",
//               crn,
//               user: user_id,
//               rep_type: "Invoice",
//               name: fileName,
//               udt: today.toISOString().split("T")[0],
//               mode: "Upload",
//               internal_name: fileName,
//               yyyymm: yymm,
//               status: "N",
//               last_update_user: user_id,
//               external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
//             });

//             alert("Payment successful & Invoice uploaded!");
//             Navigate("/invoice");
//           } catch (error) {
//             console.error("Error verifying payment:", error);
//             alert("Payment verification failed. Please contact support.");
//           }
//         },
//         prefill: {
//           name: user_name,
//           email: email,
//           contact: user_id,
//         },
//         theme: {
//           color: "#F37254",
//         },
//       };

//       const rzp1 = new window.Razorpay(options);
//       rzp1.open();
//     } catch (error) {
//       console.error("Error processing payment:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Select a Payment Plan</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
//           Please subscribe or top-up your credits to continue using this feature.
//         </p>
//         <Row className="text-center">
//           {/* 1 Year Access Plan - 100 calculations */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-primary">1 Year Access</h5>
//                 <h3>₹5,999</h3>
//                 <p>365 Days Validity</p>
//                 <p className="text-warning fw-bold">100 Calculations Included</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Testing Plan - 2 Minutes Only */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100 border-warning">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-warning">🎯 Testing Plan</h5>
//                 <h3>₹99</h3>
//                 <p>2 Minutes Only</p>
//                 <p className="text-danger fw-bold">20 Calculations Included</p>
//                 <p className="small text-muted">Limited time access for testing purposes</p>
//                 <div className="mt-auto">
//                   <Button variant="warning" className="w-100 text-white" onClick={() => handlePayment("Testing Plan (2 Mins)", 99)}>
//                     Try Now - ₹99
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Topup 50 Credits Plan */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-info">Topup Plan</h5>
//                 <h3>₹2,499</h3>
//                 <p>50 Credits</p>
//                 <p>Add 50 calculations. Old expired balance will not carry forward.</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Topup 100 Credits Plan */}
//           <Col md={4} className="mb-3 mt-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-danger">Topup Plan</h5>
//                 <h3>₹4,499</h3>
//                 <p>100 Credits</p>
//                 <p>Add 100 calculations. Old expired balance will not carry forward.</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Payment;


// 19-05-2026
// import React, { useState, useEffect } from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useUser } from "./context/UserContext";
// import { getBaseUrl } from "../api";

// const Payment = ({ show, handleClose, onPaymentSuccess, currentRemainingBalance = 0 }) => {
//   const { loggedInUser, refreshPayments, userDetails } = useUser();
//   const Navigate = useNavigate();
//   const [crn, setCrn] = useState(null);
//   const baseUrl = getBaseUrl();

//   useEffect(() => {
//     axios.post(`https://${baseUrl}/request`, {
//       object: "crn",
//       qdn: "diabrain",
//     }).then((response) => {
//       if (response.data && response.data.crn) {
//         setCrn(response.data.crn);
//       }
//     }).catch((error) => {
//       console.error("CRN fetch error:", error);
//     });
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     script.onload = () => {
//       console.log("Razorpay SDK loaded successfully.");
//     };
//     script.onerror = () => {
//       console.error("Razorpay SDK failed to load.");
//     };
//     document.body.appendChild(script);
//   }, []);
   
//   const uploadPDF = (pdfBlob, fileName, yymm) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.open("POST", `https://${baseUrl}/upload`, true);
//       xhr.setRequestHeader("x-dt", yymm);
//       xhr.setRequestHeader("x-name", fileName);
//       xhr.setRequestHeader("x-enc", "bin");
//       xhr.onload = () => {
//         if (xhr.status === 200) resolve(xhr.responseText);
//         else reject("Upload failed: " + xhr.statusText);
//       };
//       xhr.onerror = () => reject("Upload error");
//       xhr.send(pdfBlob);
//     });
//   };

//   const getCurrentDialCount = () => {
//     const fromUserDetails = userDetails?.response?.[userDetails.response.length - 1]?.dial_cnt;
//     const fromUserLocal = localStorage.getItem(`dial_cnt_${loggedInUser}`);
//     const fromGenericLocal = localStorage.getItem("dial_cnt");

//     // IMPORTANT FIX:
//     // Use the maximum available dial count, not the first value.
//     // After trial, DB/userDetails may still be stale as 0 while localStorage has 2.
//     // If we save start_dial_cnt as 0, new top-up 50 shows 48.
//     // Saving start_dial_cnt as 2 makes new top-up 50 show full 50.
//     const candidates = [fromUserDetails, fromUserLocal, fromGenericLocal]
//       .map((value) => parseInt(value ?? "0", 10))
//       .filter((value) => Number.isFinite(value) && value >= 0);

//     return candidates.length ? Math.max(...candidates) : 0;
//   };

//   const handlePayment = async (plan, amount) => {
//     try {
//       if (!window.Razorpay) {
//         alert("Razorpay SDK failed to load. Please try again.");
//         return;
//       }

//       if (!crn) {
//         alert("Please enter a valid CRN.");
//         return;
//       }

//       const today = new Date();
//       // Current Timestamp
//       const formattedDateTime = today.getFullYear() + "-" +
//         String(today.getMonth() + 1).padStart(2, "0") + "-" +
//         String(today.getDate()).padStart(2, "0") + " " +
//         String(today.getHours()).padStart(2, "0") + ":" +
//         String(today.getMinutes()).padStart(2, "0") + ":" +
//         String(today.getSeconds()).padStart(2, "0");

//       let expiryDate = new Date(today);
//       let formattedExpiryDate = "";

//       const formatDateTime = (dateObj) => {
//         return dateObj.getFullYear() + "-" +
//           String(dateObj.getMonth() + 1).padStart(2, "0") + "-" +
//           String(dateObj.getDate()).padStart(2, "0") + " " +
//           String(dateObj.getHours()).padStart(2, "0") + ":" +
//           String(dateObj.getMinutes()).padStart(2, "0") + ":" +
//           String(dateObj.getSeconds()).padStart(2, "0");
//       };

//       const parseDateTimeToMs = (dateStr) => {
//         if (!dateStr) return 0;
//         const parts = dateStr.split(/[- :]/);
//         if (parts.length >= 6) {
//           return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//         }
//         if (parts.length === 3) {
//           return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime();
//         }
//         return 0;
//       };

//       // Plan validity logic
//       if (plan === "Testing Plan (2 Mins)") {
//         // Testing: 20 calculations, 2 minutes validity
//         expiryDate.setMinutes(expiryDate.getMinutes() + 2);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits") {
//         // Top-up rule:
//         // 1) If current active plan still has remaining calculations, top-up continues the same expiry.
//         // 2) If current active plan is exhausted OR expired, top-up starts a fresh 1-year validity.
//         // Example:
//         // 1 Year plan = 100 calculations. If user used all 100 before expiry,
//         // then buying top-up must create a NEW 1-year validity, not continue old expiry.
//         const storedExpiry = localStorage.getItem("expiry_date");
//         const storedExpiryMs = parseDateTimeToMs(storedExpiry);
//         const nowMs = today.getTime();
//         const activeBalance = parseInt(currentRemainingBalance ?? "0", 10);
//         const hasActiveTime = storedExpiry && storedExpiry !== "0" && storedExpiryMs > nowMs;
//         const hasActiveCalculationBalance = Number.isFinite(activeBalance) && activeBalance > 0;

//         if (hasActiveTime && hasActiveCalculationBalance) {
//           // User is topping up before balance becomes 0, so keep current validity.
//           formattedExpiryDate = storedExpiry;
//         } else {
//           // Old plan/trial is expired OR calculations are exhausted.
//           // New top-up becomes a fresh 1-year plan window.
//           expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//           formattedExpiryDate = formatDateTime(expiryDate);
//         }
//       } else {
//         // 1 Year Access / Premium: 1 year validity
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       }

//       const user_id = localStorage.getItem("user_id");
//       const email = localStorage.getItem("email");
//       const user_name = localStorage.getItem("username");

//       // Step 1: Create Razorpay Order
//       const payload = {
//         vendor: "Razorpay",
//         amount: amount,
//       };
//       const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

//       if (orderResponse.data.status !== "00") {
//         alert("Couldn't process payment. Please try again.");
//         return;
//       }

//       // Step 2: Open Razorpay Checkout
//       const options = {
//         key: orderResponse.data.apik,
//         amount: amount,
//         currency: "INR",
//         name: "DiabWellness Private Limited",
//         description: "DiaBrain Decision Support Service",
//         image: "https://diax.ai/assets/Group%203.png",
//         order_id: orderResponse.data.details.id,
//         handler: async (paymentResponse) => {
//           try {
//             // Step 3: Verify Signature
//             const verifyPayload = {
//               payment_id: paymentResponse.razorpay_payment_id,
//               order_id: paymentResponse.razorpay_order_id,
//               signature: paymentResponse.razorpay_signature,
//             };

//             const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

//             if (verifyResponse.data.status !== "00") {
//               alert("Payment verification failed. Please retry.");
//               return;
//             }

//             // Step 4: Save Payment
//             // Read the latest used count only at successful payment time.
//             // This becomes the baseline for this new purchase.
//             const currentDialCountAtPurchase = getCurrentDialCount();

//             const paymentData = {
//               action: "A",
//               object: "payments",
//               user_id: user_id,
//               user_name: user_name,
//               reason: "DiaBrain Decision Support",
//               crn: crn,
//               order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
//               status: "Success",
//               details: JSON.stringify({
//                 payment_info: verifyResponse.data,
//                 hospital: "DiaBrain",
//                 plan: plan,
//                 amount_paid: amount,
//                 expiry_date: formattedExpiryDate,
//                 order_date: formattedDateTime,

//                 // Home.js will use this to calculate ONLY current active plan balance.
//                 // When old plan expires, old remaining balance will not carry over.
//                 start_dial_cnt: currentDialCountAtPurchase,
//                 usage_start_count: currentDialCountAtPurchase,
//                 dial_cnt_at_purchase: currentDialCountAtPurchase,
//               }),
//             };
//             await axios.post(`https://${baseUrl}/request`, paymentData);

//             await refreshPayments();

//             const formattedExpiryMs = parseDateTimeToMs(formattedExpiryDate);
//             localStorage.setItem("isSubscribed", "true");
//             localStorage.setItem("amount_paid", amount);
//             localStorage.setItem("expiry_date", formattedExpiryDate);
//             localStorage.setItem("expiry_timestamp", formattedExpiryMs.toString());
//             localStorage.setItem("order_date", formattedDateTime);
//             localStorage.setItem(`active_usage_baseline_${loggedInUser}`, currentDialCountAtPurchase.toString());

//             if (onPaymentSuccess) await onPaymentSuccess();

//             // Testing plan time validity is only for display.
//             // Do NOT force subscription false after 2 minutes if calculations remain.
//             // Home.js will continue allowing access until remaining balance becomes 0.

//             alert("Payment successful! Subscription/Topup is active.");

//             // Step 5: Save Bill
//             const billsave = {
//               action: "A",
//               object: "bill",
//               bill_type: "Invoice",
//               bill_class: "DiaBrain Decision Support",
//               user_id: user_id,
//               user_name: user_name,
//               total: amount,
//               crn: parseInt(crn),
//               bill_det: JSON.stringify({
//                 Item: `DiaBrain Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//                 amount: amount,
//                 quantity: "1",
//               }),
//             };
//             const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
//             const bill_num = saveResponse.data.bill_num;
//             console.log("bill",bill_num);
//             if (!bill_num) throw new Error("Bill number not returned");

//             // Step 6: Generate Invoice PDF
//             const doc = new jsPDF();
//             doc.setFontSize(22);
//             doc.text("INVOICE", 80, 15);
//             doc.setFontSize(12);
//             doc.text(`Invoice No: ${bill_num}`, 14, 30);
//             doc.text(`Date: ${formattedDateTime}`, 14, 40);
//             doc.text(`User Name: ${user_name}`, 14, 50);
//             doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
//             doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

//             const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
//             const basePrice = amount / 1.18;
//             const gstValue = amount - basePrice;
//             const data = [[
//               `DiaBrain Decision Supports ${plan} - Expiry ${formattedExpiryDate}`,
//               "1",
//               `Rs.${basePrice.toFixed(2)}`,
//               `Rs.${gstValue.toFixed(2)}`,
//               `Rs.${amount.toFixed(2)}`,
//             ]];

//             autoTable(doc, {
//               startY: 80,
//               head: headers,
//               body: data,
//               theme: "grid",
//               styles: { fontSize: 10, cellPadding: 3 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
//               bodyStyles: { fontStyle: "bold" },
//             });

//             doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

//             const pdfBlob = doc.output("blob");
//             const nowmm = new Date().getMonth() + 1;
//             const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
//             const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

//             await uploadPDF(pdfBlob, fileName, yymm);

//             // Step 7: Upload to repos
//             await axios.post(`https://${baseUrl}/request`, {
//               action: "A",
//               object: "repos",
//               crn,
//               user: user_id,
//               rep_type: "Invoice",
//               name: fileName,
//               udt: today.toISOString().split("T")[0],
//               mode: "Upload",
//               internal_name: fileName,
//               yyyymm: yymm,
//               status: "N",
//               last_update_user: user_id,
//               external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
//             });

//             alert("Payment successful & Invoice uploaded!");
//             Navigate("/invoice");
//           } catch (error) {
//             console.error("Error verifying payment:", error);
//             alert("Payment verification failed. Please contact support.");
//           }
//         },
//         prefill: {
//           name: user_name,
//           email: email,
//           contact: user_id,
//         },
//         theme: {
//           color: "#F37254",
//         },
//       };

//       const rzp1 = new window.Razorpay(options);
//       rzp1.open();
//     } catch (error) {
//       console.error("Error processing payment:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Select a Payment Plan</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
//           Please subscribe or top-up your credits to continue using this feature.
//         </p>
//         <Row className="text-center">
//           {/* 1 Year Access Plan - 100 calculations */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-primary">1 Year Access</h5>
//                 <h3>₹5,999</h3>
//                 <p>365 Days Validity</p>
//                 <p className="text-warning fw-bold">100 Credits</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Testing Plan - 2 Minutes Only 
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100 border-warning">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-warning">🎯 Testing Plan</h5>
//                 <h3>₹5</h3>
//                 <p>2 Minutes Only</p>
//                 <p className="text-danger fw-bold">20 Calculations Included</p>
//                 <p className="small text-muted">Limited time access for testing purposes</p>
//                 <div className="mt-auto">
//                   <Button variant="warning" className="w-100 text-white" onClick={() => handlePayment("Testing Plan (2 Mins)", 5)}>
//                     Try Now - ₹5
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>*/}

//           {/* Topup 50 Credits Plan */}
//           <Col md={4} className="mb-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-info">Topup Plan</h5>
//                 <h3>₹2,499</h3>
//                   <p>365 Days Validity</p>
//                 <p className="text-warning fw-bold">50 Credits</p>
//                 {/* <p>Add 50 calculations. If old balance is 0, new 1-year validity starts.</p> */}
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           {/* Topup 100 Credits Plan */}
//           <Col md={4} className="mb-3 mt-3">
//             <Card className="shadow p-3 h-100">
//               <Card.Body className="d-flex flex-column">
//                 <h5 className="text-danger">Topup Plan</h5>
//                 <h3>₹4,499</h3>
//                 {/* <p>100 Credits</p>
//                 <p>Add 100 calculations. If old balance is 0, new 1-year validity starts.</p>
//                  */}
//                    <p>365 Days Validity</p>
//                 <p className="text-warning fw-bold">100 Credits</p>
//                 <div className="mt-auto">
//                   <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
//                     Proceed to Pay
//                   </Button>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Payment;

// import React, { useState, useEffect } from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useUser } from "./context/UserContext";
// import { getBaseUrl } from "../api";

// const Payment = ({ show, handleClose, onPaymentSuccess, currentRemainingBalance = 0 }) => {
//   const { loggedInUser, refreshPayments, userDetails } = useUser();
//   const Navigate = useNavigate();
//   const [crn, setCrn] = useState(null);
//   const baseUrl = getBaseUrl();

//   // ✅ Check if user is first-time (dial_cnt === 0)
//   const dialCnt = parseInt(localStorage.getItem(`dial_cnt_${loggedInUser}`) || localStorage.getItem("dial_cnt") || "0", 10);
//   const isFirstTimeUser = dialCnt === 0;

//   useEffect(() => {
//     axios.post(`https://${baseUrl}/request`, {
//       object: "crn",
//       qdn: "diabrain",
//     }).then((response) => {
//       if (response.data && response.data.crn) {
//         setCrn(response.data.crn);
//       }
//     }).catch((error) => {
//       console.error("CRN fetch error:", error);
//     });
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     script.onload = () => {
//       console.log("Razorpay SDK loaded successfully.");
//     };
//     script.onerror = () => {
//       console.error("Razorpay SDK failed to load.");
//     };
//     document.body.appendChild(script);
//   }, []);

//   const uploadPDF = (pdfBlob, fileName, yymm) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.open("POST", `https://${baseUrl}/upload`, true);
//       xhr.setRequestHeader("x-dt", yymm);
//       xhr.setRequestHeader("x-name", fileName);
//       xhr.setRequestHeader("x-enc", "bin");
//       xhr.onload = () => {
//         if (xhr.status === 200) resolve(xhr.responseText);
//         else reject("Upload failed: " + xhr.statusText);
//       };
//       xhr.onerror = () => reject("Upload error");
//       xhr.send(pdfBlob);
//     });
//   };

//   const getCurrentDialCount = () => {
//     const fromUserDetails = userDetails?.response?.[userDetails.response.length - 1]?.dial_cnt;
//     const fromUserLocal = localStorage.getItem(`dial_cnt_${loggedInUser}`);
//     const fromGenericLocal = localStorage.getItem("dial_cnt");

//     const candidates = [fromUserDetails, fromUserLocal, fromGenericLocal]
//       .map((value) => parseInt(value ?? "0", 10))
//       .filter((value) => Number.isFinite(value) && value >= 0);

//     return candidates.length ? Math.max(...candidates) : 0;
//   };

//   const handlePayment = async (plan, amount) => {
//     try {
//       if (!window.Razorpay) {
//         alert("Razorpay SDK failed to load. Please try again.");
//         return;
//       }

//       if (!crn) {
//         alert("Please enter a valid CRN.");
//         return;
//       }

//       const today = new Date();
//       const formattedDateTime = today.getFullYear() + "-" +
//         String(today.getMonth() + 1).padStart(2, "0") + "-" +
//         String(today.getDate()).padStart(2, "0") + " " +
//         String(today.getHours()).padStart(2, "0") + ":" +
//         String(today.getMinutes()).padStart(2, "0") + ":" +
//         String(today.getSeconds()).padStart(2, "0");

//       let expiryDate = new Date(today);
//       let formattedExpiryDate = "";

//       const formatDateTime = (dateObj) => {
//         return dateObj.getFullYear() + "-" +
//           String(dateObj.getMonth() + 1).padStart(2, "0") + "-" +
//           String(dateObj.getDate()).padStart(2, "0") + " " +
//           String(dateObj.getHours()).padStart(2, "0") + ":" +
//           String(dateObj.getMinutes()).padStart(2, "0") + ":" +
//           String(dateObj.getSeconds()).padStart(2, "0");
//       };

//       const parseDateTimeToMs = (dateStr) => {
//         if (!dateStr) return 0;
//         const parts = dateStr.split(/[- :]/);
//         if (parts.length >= 6) {
//           return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//         }
//         if (parts.length === 3) {
//           return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime();
//         }
//         return 0;
//       };

//       // if (plan === "Testing Plan (2 Mins)") {
//       //   expiryDate.setMinutes(expiryDate.getMinutes() + 2);
//       //   formattedExpiryDate = formatDateTime(expiryDate);
//       // } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits") {
//       //   const storedExpiry = localStorage.getItem("expiry_date");
//       //   const storedExpiryMs = parseDateTimeToMs(storedExpiry);
//       //   const nowMs = today.getTime();
//       //   const activeBalance = parseInt(currentRemainingBalance ?? "0", 10);
//       //   const hasActiveTime = storedExpiry && storedExpiry !== "0" && storedExpiryMs > nowMs;
//       //   const hasActiveCalculationBalance = Number.isFinite(activeBalance) && activeBalance > 0;

//       //   if (hasActiveTime && hasActiveCalculationBalance) {
//       //     formattedExpiryDate = storedExpiry;
//       //   } else {
//       //     expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//       //     formattedExpiryDate = formatDateTime(expiryDate);
//       //   }
//       // } else {
//       //   expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//       //   formattedExpiryDate = formatDateTime(expiryDate);
//       // }

//       if (plan === "Testing Plan (2 Mins)") {
//         expiryDate.setMinutes(expiryDate.getMinutes() + 2);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       } else if (plan === "Topup 5 Credits") {
//         // ✅ Sets exact 30 days validity for the ₹299 plan
//         expiryDate.setDate(expiryDate.getDate() + 30);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits") {
//         const storedExpiry = localStorage.getItem("expiry_date");
//         const storedExpiryMs = parseDateTimeToMs(storedExpiry);
//         const nowMs = today.getTime();
//         const activeBalance = parseInt(currentRemainingBalance ?? "0", 10);
//         const hasActiveTime = storedExpiry && storedExpiry !== "0" && storedExpiryMs > nowMs;
//         const hasActiveCalculationBalance = Number.isFinite(activeBalance) && activeBalance > 0;

//         if (hasActiveTime && hasActiveCalculationBalance) {
//           formattedExpiryDate = storedExpiry;
//         } else {
//           expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//           formattedExpiryDate = formatDateTime(expiryDate);
//         }
//       } else {
//         // Fallback for 1-year plans
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       }

//       const user_id = localStorage.getItem("user_id");
//       const email = localStorage.getItem("email");
//       const user_name = localStorage.getItem("username");

//       const payload = { vendor: "Razorpay", amount: amount };
//       const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

//       if (orderResponse.data.status !== "00") {
//         alert("Couldn't process payment. Please try again.");
//         return;
//       }

//       const options = {
//         key: orderResponse.data.apik,
//         amount: amount,
//         currency: "INR",
//         name: "DiabWellness Private Limited",
//         description: "DiaBrain Decision Support Service",
//         image: "https://diax.ai/assets/Group%203.png",
//         order_id: orderResponse.data.details.id,
//         handler: async (paymentResponse) => {
//           try {
//             const verifyPayload = {
//               payment_id: paymentResponse.razorpay_payment_id,
//               order_id: paymentResponse.razorpay_order_id,
//               signature: paymentResponse.razorpay_signature,
//             };

//             const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

//             if (verifyResponse.data.status !== "00") {
//               alert("Payment verification failed. Please retry.");
//               return;
//             }

//             const currentDialCountAtPurchase = getCurrentDialCount();

//             const paymentData = {
//               action: "A",
//               object: "payments",
//               user_id: user_id,
//               user_name: user_name,
//               reason: "DiaBrain Decision Support",
//               crn: crn,
//               order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
//               status: "Success",
//               details: JSON.stringify({
//                 payment_info: verifyResponse.data,
//                 hospital: "DiaBrain",
//                 plan: plan,
//                 amount_paid: amount,
//                 expiry_date: formattedExpiryDate,
//                 order_date: formattedDateTime,
//                 start_dial_cnt: currentDialCountAtPurchase,
//                 usage_start_count: currentDialCountAtPurchase,
//                 dial_cnt_at_purchase: currentDialCountAtPurchase,
//               }),
//             };
//             await axios.post(`https://${baseUrl}/request`, paymentData);

//             await refreshPayments();

//             const formattedExpiryMs = parseDateTimeToMs(formattedExpiryDate);
//             localStorage.setItem("isSubscribed", "true");
//             localStorage.setItem("amount_paid", amount);
//             localStorage.setItem("expiry_date", formattedExpiryDate);
//             localStorage.setItem("expiry_timestamp", formattedExpiryMs.toString());
//             localStorage.setItem("order_date", formattedDateTime);
//             localStorage.setItem(`active_usage_baseline_${loggedInUser}`, currentDialCountAtPurchase.toString());

//             if (onPaymentSuccess) await onPaymentSuccess();

//             alert("Payment successful! Subscription/Topup is active.");

//             const billsave = {
//               action: "A",
//               object: "bill",
//               bill_type: "Invoice",
//               bill_class: "DiaBrain Decision Support",
//               user_id: user_id,
//               user_name: user_name,
//               total: amount,
//               crn: parseInt(crn),
//               bill_det: JSON.stringify({
//                 Item: `DiaBrain Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//                 amount: amount,
//                 quantity: "1",
//               }),
//             };
//             const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
//             const bill_num = saveResponse.data.bill_num;
//             console.log("bill", bill_num);
//             if (!bill_num) throw new Error("Bill number not returned");

//             const doc = new jsPDF();
//             doc.setFontSize(22);
//             doc.text("INVOICE", 80, 15);
//             doc.setFontSize(12);
//             doc.text(`Invoice No: ${bill_num}`, 14, 30);
//             doc.text(`Date: ${formattedDateTime}`, 14, 40);
//             doc.text(`User Name: ${user_name}`, 14, 50);
//             doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
//             doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

//             const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
//             const basePrice = amount / 1.18;
//             const gstValue = amount - basePrice;
//             const data = [[
//               `DiaBrain Decision Supports ${plan} - Expiry ${formattedExpiryDate}`,
//               "1",
//               `Rs.${basePrice.toFixed(2)}`,
//               `Rs.${gstValue.toFixed(2)}`,
//               `Rs.${amount.toFixed(2)}`,
//             ]];

//             autoTable(doc, {
//               startY: 80,
//               head: headers,
//               body: data,
//               theme: "grid",
//               styles: { fontSize: 10, cellPadding: 3 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
//               bodyStyles: { fontStyle: "bold" },
//             });

//             doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

//             const pdfBlob = doc.output("blob");
//             const nowmm = new Date().getMonth() + 1;
//             const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
//             const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

//             await uploadPDF(pdfBlob, fileName, yymm);

//             await axios.post(`https://${baseUrl}/request`, {
//               action: "A",
//               object: "repos",
//               crn,
//               user: user_id,
//               rep_type: "Invoice",
//               name: fileName,
//               udt: today.toISOString().split("T")[0],
//               mode: "Upload",
//               internal_name: fileName,
//               yyyymm: yymm,
//               status: "N",
//               last_update_user: user_id,
//               external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
//             });

//             alert("Payment successful & Invoice uploaded!");
//             Navigate("/invoice");
//           } catch (error) {
//             console.error("Error verifying payment:", error);
//             alert("Payment verification failed. Please contact support.");
//           }
//         },
//         prefill: {
//           name: user_name,
//           email: email,
//           contact: user_id,
//         },
//         theme: { color: "#F37254" },
//       };

//       const rzp1 = new window.Razorpay(options);
//       rzp1.open();
//     } catch (error) {
//       console.error("Error processing payment:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Select a Payment Plan</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
//           Please subscribe or top-up your credits to continue using this feature.
//         </p>

//         <Row className="text-center justify-content-center">

//           {/* ✅ Show ONLY 1 Year Plan for first-time users (dial_cnt === 0) */}
//           {isFirstTimeUser && (
//             <>
//             <Col md={5} className="mb-3">
//                 <Card className="shadow p-3 h-100">
//                   <Card.Body className="d-flex flex-column">
//                     <h5 className="text-info">Topup Plan</h5>
//                     <h3>₹299</h3>
//                     <p>30 Days Validity</p>
//                     <p className="text-warning fw-bold">5 Credits</p>
//                     <div className="mt-auto">
//                       <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 5 Credits", 299)}>
//                         Proceed to Pay
//                       </Button>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             <Col md={6} className="mb-3">
//               <Card className="shadow p-3 h-100 border-primary">
//                 <Card.Body className="d-flex flex-column">
//                   <h5 className="text-primary">1 Year Access</h5>
//                   <h3>₹5,999</h3>
//                   <p>365 Days Validity</p>
//                   <p className="text-warning fw-bold">100 Credits</p>
//                   <div className="mt-auto">
//                     <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
//                       Proceed to Pay
//                     </Button>
//                   </div>
//                 </Card.Body>
//               </Card>
//             </Col>
               
//               </>
//           )}

//           {/* ✅ Show ONLY Topup Plans for existing users (dial_cnt > 0) */}
//           {!isFirstTimeUser && (
//             <>

          

//               <Col md={5} className="mb-3">
//                 <Card className="shadow p-3 h-100">
//                   <Card.Body className="d-flex flex-column">
//                     <h5 className="text-info">Topup Plan</h5>
//                     <h3>₹2,499</h3>
//                     <p>365 Days Validity</p>
//                     <p className="text-warning fw-bold">50 Credits</p>
//                     <div className="mt-auto">
//                       <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
//                         Proceed to Pay
//                       </Button>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>

//               <Col md={5} className="mb-3">
//                 <Card className="shadow p-3 h-100">
//                   <Card.Body className="d-flex flex-column">
//                     <h5 className="text-danger">Topup Plan</h5>
//                     <h3>₹4,499</h3>
//                     <p>365 Days Validity</p>
//                     <p className="text-warning fw-bold">100 Credits</p>
//                     <div className="mt-auto">
//                       <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
//                         Proceed to Pay
//                       </Button>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </>
//           )}

//         </Row>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Payment;

// 01-06-2026

// import React, { useState, useEffect } from "react";
// import { Modal, Button, Row, Col, Card } from "react-bootstrap";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useUser } from "./context/UserContext";
// import { getBaseUrl } from "../api";

// const Payment = ({ show, handleClose, onPaymentSuccess, currentRemainingBalance = 0 }) => {
//   const { loggedInUser, refreshPayments, userDetails } = useUser();
//   const Navigate = useNavigate();
//   const [crn, setCrn] = useState(null);
//   const baseUrl = getBaseUrl();
  
//   // State to track what plan user purchased first
//   const [userFirstPlan, setUserFirstPlan] = useState(null);
//   // State to check if user has ever purchased 5999 plan
//   const [hasPurchased5999, setHasPurchased5999] = useState(false);

//   // ✅ Check if user is first-time (dial_cnt === 0)
//   const dialCnt = parseInt(localStorage.getItem(`dial_cnt_${loggedInUser}`) || localStorage.getItem("dial_cnt") || "0", 10);
//   const isFirstTimeUser = dialCnt === 0;

//   // Get the user's purchase history from localStorage on component mount
//   useEffect(() => {
//     const storedFirstPlan = localStorage.getItem(`user_first_plan_${loggedInUser}`);
//     const storedHas5999 = localStorage.getItem(`has_purchased_5999_${loggedInUser}`);
    
//     if (storedFirstPlan) {
//       setUserFirstPlan(storedFirstPlan);
//     }
    
//     if (storedHas5999 === "true") {
//       setHasPurchased5999(true);
//     }
//   }, [loggedInUser]);

//   // Check user's payment history from backend when modal opens
//   useEffect(() => {
//     if (show && loggedInUser) {
//       checkUserPurchaseHistory();
//     }
//   }, [show, loggedInUser]);

//   const checkUserPurchaseHistory = async () => {
//     try {
//       const user_id = localStorage.getItem("user_id");
//       if (!user_id) return;

//       // Fetch user's payment history
//       const response = await axios.post(`https://${baseUrl}/request`, {
//         action: "R",
//         object: "payments",
//         user_id: user_id,
//         status: "Success"
//       });

//       if (response.data && response.data.response) {
//         const payments = response.data.response;
        
//         // Check if user has ever purchased 5999 plan
//         const has5999Purchase = payments.some(payment => {
//           try {
//             const details = typeof payment.details === 'string' ? JSON.parse(payment.details) : payment.details;
//             return details.plan === "1 Year Access" && details.amount_paid === 5999;
//           } catch (e) {
//             return false;
//           }
//         });

//         // Check if user has purchased 299 plan
//         const has299Purchase = payments.some(payment => {
//           try {
//             const details = typeof payment.details === 'string' ? JSON.parse(payment.details) : payment.details;
//             return details.plan === "Topup 5 Credits" && details.amount_paid === 299;
//           } catch (e) {
//             return false;
//           }
//         });

//         // Determine first plan type
//         if (has299Purchase && !has5999Purchase) {
//           setUserFirstPlan("basic");
//           localStorage.setItem(`user_first_plan_${loggedInUser}`, "basic");
//         } else if (has5999Purchase) {
//           setUserFirstPlan("premium");
//           localStorage.setItem(`user_first_plan_${loggedInUser}`, "premium");
//           setHasPurchased5999(true);
//           localStorage.setItem(`has_purchased_5999_${loggedInUser}`, "true");
//         }
//       }
//     } catch (error) {
//       console.error("Error checking payment history:", error);
//     }
//   };

//   useEffect(() => {
//     axios.post(`https://${baseUrl}/request`, {
//       object: "crn",
//       qdn: "diabrain",
//     }).then((response) => {
//       if (response.data && response.data.crn) {
//         setCrn(response.data.crn);
//       }
//     }).catch((error) => {
//       console.error("CRN fetch error:", error);
//     });
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     script.onload = () => {
//       console.log("Razorpay SDK loaded successfully.");
//     };
//     script.onerror = () => {
//       console.error("Razorpay SDK failed to load.");
//     };
//     document.body.appendChild(script);
//   }, []);

//   const uploadPDF = (pdfBlob, fileName, yymm) => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();
//       xhr.open("POST", `https://${baseUrl}/upload`, true);
//       xhr.setRequestHeader("x-dt", yymm);
//       xhr.setRequestHeader("x-name", fileName);
//       xhr.setRequestHeader("x-enc", "bin");
//       xhr.onload = () => {
//         if (xhr.status === 200) resolve(xhr.responseText);
//         else reject("Upload failed: " + xhr.statusText);
//       };
//       xhr.onerror = () => reject("Upload error");
//       xhr.send(pdfBlob);
//     });
//   };

//   const getCurrentDialCount = () => {
//     const fromUserDetails = userDetails?.response?.[userDetails.response.length - 1]?.dial_cnt;
//     const fromUserLocal = localStorage.getItem(`dial_cnt_${loggedInUser}`);
//     const fromGenericLocal = localStorage.getItem("dial_cnt");

//     const candidates = [fromUserDetails, fromUserLocal, fromGenericLocal]
//       .map((value) => parseInt(value ?? "0", 10))
//       .filter((value) => Number.isFinite(value) && value >= 0);

//     return candidates.length ? Math.max(...candidates) : 0;
//   };

//   const handlePayment = async (plan, amount) => {
//     try {
//       if (!window.Razorpay) {
//         alert("Razorpay SDK failed to load. Please try again.");
//         return;
//       }

//       if (!crn) {
//         alert("Please enter a valid CRN.");
//         return;
//       }

//       const today = new Date();
//       const formattedDateTime = today.getFullYear() + "-" +
//         String(today.getMonth() + 1).padStart(2, "0") + "-" +
//         String(today.getDate()).padStart(2, "0") + " " +
//         String(today.getHours()).padStart(2, "0") + ":" +
//         String(today.getMinutes()).padStart(2, "0") + ":" +
//         String(today.getSeconds()).padStart(2, "0");

//       let expiryDate = new Date(today);
//       let formattedExpiryDate = "";

//       const formatDateTime = (dateObj) => {
//         return dateObj.getFullYear() + "-" +
//           String(dateObj.getMonth() + 1).padStart(2, "0") + "-" +
//           String(dateObj.getDate()).padStart(2, "0") + " " +
//           String(dateObj.getHours()).padStart(2, "0") + ":" +
//           String(dateObj.getMinutes()).padStart(2, "0") + ":" +
//           String(dateObj.getSeconds()).padStart(2, "0");
//       };

//       const parseDateTimeToMs = (dateStr) => {
//         if (!dateStr) return 0;
//         const parts = dateStr.split(/[- :]/);
//         if (parts.length >= 6) {
//           return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//         }
//         if (parts.length === 3) {
//           return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime();
//         }
//         return 0;
//       };

//       if (plan === "Testing Plan (2 Mins)") {
//         expiryDate.setMinutes(expiryDate.getMinutes() + 2);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       } else if (plan === "Topup 5 Credits") {
//         expiryDate.setDate(expiryDate.getDate() + 30);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits" || plan === "1 Year Access") {
//         const storedExpiry = localStorage.getItem("expiry_date");
//         const storedExpiryMs = parseDateTimeToMs(storedExpiry);
//         const nowMs = today.getTime();
//         const activeBalance = parseInt(currentRemainingBalance ?? "0", 10);
//         const hasActiveTime = storedExpiry && storedExpiry !== "0" && storedExpiryMs > nowMs;
//         const hasActiveCalculationBalance = Number.isFinite(activeBalance) && activeBalance > 0;

//         if (hasActiveTime && hasActiveCalculationBalance) {
//           formattedExpiryDate = storedExpiry;
//         } else {
//           expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//           formattedExpiryDate = formatDateTime(expiryDate);
//         }
//       } else {
//         expiryDate.setFullYear(expiryDate.getFullYear() + 1);
//         formattedExpiryDate = formatDateTime(expiryDate);
//       }

//       const user_id = localStorage.getItem("user_id");
//       const email = localStorage.getItem("email");
//       const user_name = localStorage.getItem("username");

//       const payload = { vendor: "Razorpay", amount: amount };
//       const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

//       if (orderResponse.data.status !== "00") {
//         alert("Couldn't process payment. Please try again.");
//         return;
//       }

//       const options = {
//         key: orderResponse.data.apik,
//         amount: amount,
//         currency: "INR",
//         name: "DiabWellness Private Limited",
//         description: "DiaBrain Decision Support Service",
//         image: "https://diax.ai/assets/Group%203.png",
//         order_id: orderResponse.data.details.id,
//         handler: async (paymentResponse) => {
//           try {
//             const verifyPayload = {
//               payment_id: paymentResponse.razorpay_payment_id,
//               order_id: paymentResponse.razorpay_order_id,
//               signature: paymentResponse.razorpay_signature,
//             };

//             const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

//             if (verifyResponse.data.status !== "00") {
//               alert("Payment verification failed. Please retry.");
//               return;
//             }

//             const currentDialCountAtPurchase = getCurrentDialCount();

//             const paymentData = {
//               action: "A",
//               object: "payments",
//               user_id: user_id,
//               user_name: user_name,
//               reason: "DiaBrain Decision Support",
//               crn: crn,
//               order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
//               status: "Success",
//               details: JSON.stringify({
//                 payment_info: verifyResponse.data,
//                 hospital: "DiaBrain",
//                 plan: plan,
//                 amount_paid: amount,
//                 expiry_date: formattedExpiryDate,
//                 order_date: formattedDateTime,
//                 start_dial_cnt: currentDialCountAtPurchase,
//                 usage_start_count: currentDialCountAtPurchase,
//                 dial_cnt_at_purchase: currentDialCountAtPurchase,
//               }),
//             };
//             await axios.post(`https://${baseUrl}/request`, paymentData);

//             await refreshPayments();

//             const formattedExpiryMs = parseDateTimeToMs(formattedExpiryDate);
//             localStorage.setItem("isSubscribed", "true");
//             localStorage.setItem("amount_paid", amount);
//             localStorage.setItem("expiry_date", formattedExpiryDate);
//             localStorage.setItem("expiry_timestamp", formattedExpiryMs.toString());
//             localStorage.setItem("order_date", formattedDateTime);
//             localStorage.setItem(`active_usage_baseline_${loggedInUser}`, currentDialCountAtPurchase.toString());
            
//             // Store the plan type for first-time user
//             if (isFirstTimeUser) {
//               if (plan === "Topup 5 Credits") {
//                 localStorage.setItem(`user_first_plan_${loggedInUser}`, "basic");
//                 setUserFirstPlan("basic");
//               } else if (plan === "1 Year Access") {
//                 localStorage.setItem(`user_first_plan_${loggedInUser}`, "premium");
//                 setUserFirstPlan("premium");
//                 localStorage.setItem(`has_purchased_5999_${loggedInUser}`, "true");
//                 setHasPurchased5999(true);
//               }
//             } else {
//               // For existing users, update 5999 purchase status if they buy it now
//               if (plan === "1 Year Access" && amount === 5999) {
//                 localStorage.setItem(`has_purchased_5999_${loggedInUser}`, "true");
//                 setHasPurchased5999(true);
//               }
//             }

//             if (onPaymentSuccess) await onPaymentSuccess();

//             alert("Payment successful! Subscription/Topup is active.");

//             const billsave = {
//               action: "A",
//               object: "bill",
//               bill_type: "Invoice",
//               bill_class: "DiaBrain Decision Support",
//               user_id: user_id,
//               user_name: user_name,
//               total: amount,
//               crn: parseInt(crn),
//               bill_det: JSON.stringify({
//                 Item: `DiaBrain Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
//                 amount: amount,
//                 quantity: "1",
//               }),
//             };
//             const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
//             const bill_num = saveResponse.data.bill_num;
//             console.log("bill", bill_num);
//             if (!bill_num) throw new Error("Bill number not returned");

//             const doc = new jsPDF();
//             doc.setFontSize(22);
//             doc.text("INVOICE", 80, 15);
//             doc.setFontSize(12);
//             doc.text(`Invoice No: ${bill_num}`, 14, 30);
//             doc.text(`Date: ${formattedDateTime}`, 14, 40);
//             doc.text(`User Name: ${user_name}`, 14, 50);
//             doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
//             doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

//             const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
//             const basePrice = amount / 1.18;
//             const gstValue = amount - basePrice;
//             const data = [[
//               `DiaBrain Decision Supports ${plan} - Expiry ${formattedExpiryDate}`,
//               "1",
//               `Rs.${basePrice.toFixed(2)}`,
//               `Rs.${gstValue.toFixed(2)}`,
//               `Rs.${amount.toFixed(2)}`,
//             ]];

//             autoTable(doc, {
//               startY: 80,
//               head: headers,
//               body: data,
//               theme: "grid",
//               styles: { fontSize: 10, cellPadding: 3 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
//               bodyStyles: { fontStyle: "bold" },
//             });

//             doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

//             const pdfBlob = doc.output("blob");
//             const nowmm = new Date().getMonth() + 1;
//             const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
//             const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

//             await uploadPDF(pdfBlob, fileName, yymm);

//             await axios.post(`https://${baseUrl}/request`, {
//               action: "A",
//               object: "repos",
//               crn,
//               user: user_id,
//               rep_type: "Invoice",
//               name: fileName,
//               udt: today.toISOString().split("T")[0],
//               mode: "Upload",
//               internal_name: fileName,
//               yyyymm: yymm,
//               status: "N",
//               last_update_user: user_id,
//               external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
//             });

//             alert("Payment successful & Invoice uploaded!");
//             Navigate("/invoice");
//           } catch (error) {
//             console.error("Error verifying payment:", error);
//             alert("Payment verification failed. Please contact support.");
//           }
//         },
//         prefill: {
//           name: user_name,
//           email: email,
//           contact: user_id,
//         },
//         theme: { color: "#F37254" },
//       };

//       const rzp1 = new window.Razorpay(options);
//       rzp1.open();
//     } catch (error) {
//       console.error("Error processing payment:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   // Determine what plans to show based on user's purchase history
//   const shouldShowPlan = (planName, amount) => {
//     // If user is first time, show both options
//     if (isFirstTimeUser) {
//       return true;
//     }
    
//     // If this is the 5999 plan and user has already purchased it, hide it
//     if (planName === "1 Year Access" && amount === 5999 && hasPurchased5999) {
//       return false;
//     }
    
//     // For existing users, show all other plans (2499, 4499)
//     return true;
//   };

//   return (
//     <Modal show={show} onHide={handleClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Select a Payment Plan</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
//           Please subscribe or top-up your credits to continue using this feature.
//         </p>

//         <Row className="text-center justify-content-center">

//           {/* ✅ Show First Time User Options (₹299 and ₹5,999) */}
//           {isFirstTimeUser && (
//             <>
//               <Col md={5} className="mb-3">
//                 <Card className="shadow p-3 h-100">
//                   <Card.Body className="d-flex flex-column">
//                     <h5 className="text-info">Topup Plan</h5>
//                     <h3>₹299</h3>
//                     <p>30 Days Validity</p>
//                     <p className="text-warning fw-bold">25 Credits</p>
//                     <div className="mt-auto">
//                       <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 25 Credits", 299)}>
//                         Proceed to Pay
//                       </Button>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
              
//               <Col md={5} className="mb-3">
//                 <Card className="shadow p-3 h-100 border-primary">
//                   <Card.Body className="d-flex flex-column">
//                     <h5 className="text-primary">1 Year Access</h5>
//                     <h3>₹5,999</h3>
//                     <p>365 Days Validity</p>
//                     <p className="text-warning fw-bold">100 Credits</p>
//                     <div className="mt-auto">
//                       <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
//                         Proceed to Pay
//                       </Button>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </>
//           )}

//           {/* ✅ Show Topup / Upgrade options for Existing Users */}
//           {!isFirstTimeUser && (
//             <>
//               {/* Show ₹2,499 plan for all existing users */}
//               {shouldShowPlan("Topup 50 Credits", 2499) && (
//                 <Col md={4} className="mb-3">
//                   <Card className="shadow p-3 h-100">
//                     <Card.Body className="d-flex flex-column">
//                       <h5 className="text-info">Topup Plan</h5>
//                       <h3>₹2,499</h3>
//                       <p>365 Days Validity</p>
//                       <p className="text-warning fw-bold">50 Credits</p>
//                       <div className="mt-auto">
//                         <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
//                           Proceed to Pay
//                         </Button>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               )}

//               {/* Show ₹4,499 plan for all existing users */}
//               {shouldShowPlan("Topup 100 Credits", 4499) && (
//                 <Col md={4} className="mb-3">
//                   <Card className="shadow p-3 h-100">
//                     <Card.Body className="d-flex flex-column">
//                       <h5 className="text-danger">Topup Plan</h5>
//                       <h3>₹4,499</h3>
//                       <p>365 Days Validity</p>
//                       <p className="text-warning fw-bold">100 Credits</p>
//                       <div className="mt-auto">
//                         <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
//                           Proceed to Pay
//                         </Button>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               )}

//               {/* Show ₹5,999 plan ONLY if user has never purchased it before */}
//               {shouldShowPlan("1 Year Access", 5999) && (
//                 <Col md={4} className="mb-3">
//                   <Card className="shadow p-3 h-100 border-primary">
//                     <Card.Body className="d-flex flex-column">
//                       <h5 className="text-primary">1 Year Access</h5>
//                       <h3>₹5,999</h3>
//                       <p>365 Days Validity</p>
//                       <p className="text-warning fw-bold">100 Credits</p>
//                       <div className="mt-auto">
//                         <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
//                           Proceed to Pay
//                         </Button>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               )}
//             </>
//           )}

//         </Row>
        
//         {/* Optional: Add a note for users who already purchased 5999 plan */}
//         {/* {!isFirstTimeUser && hasPurchased5999 && (
//           <div className="text-center mt-3 text-muted small">
//             <i>Note: You have already purchased the 1 Year Access plan. You can now top up with additional credits.</i>
//           </div>
//         )} */}
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default Payment;

import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Card } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useUser } from "./context/UserContext";
import { getBaseUrl } from "../api";

const Payment = ({ show, handleClose, onPaymentSuccess, currentRemainingBalance = 0 }) => {
  const { loggedInUser, refreshPayments, userDetails } = useUser();
  const Navigate = useNavigate();
  const [crn, setCrn] = useState(null);
  const baseUrl = getBaseUrl();
  
  // States to track specific purchases
  const [hasPurchased299, setHasPurchased299] = useState(false);
  const [hasPurchased5999, setHasPurchased5999] = useState(false);

  // Derived logic for what to show
  const show299 = !hasPurchased299 && !hasPurchased5999;
  const show5999 = !hasPurchased5999; 
  const showTopups = hasPurchased5999; // Show 2499 and 4499 ONLY after 5999 is bought

  // Get the user's purchase history from localStorage on component mount
  useEffect(() => {
    const storedHas299 = localStorage.getItem(`has_purchased_299_${loggedInUser}`);
    const storedHas5999 = localStorage.getItem(`has_purchased_5999_${loggedInUser}`);
    
    if (storedHas299 === "true") setHasPurchased299(true);
    if (storedHas5999 === "true") setHasPurchased5999(true);
  }, [loggedInUser]);

  // Check user's payment history from backend when modal opens
  useEffect(() => {
    if (show && loggedInUser) {
      checkUserPurchaseHistory();
    }
  }, [show, loggedInUser]);

  const checkUserPurchaseHistory = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      if (!user_id) return;

      const response = await axios.post(`https://${baseUrl}/request`, {
        action: "R",
        object: "payments",
        user_id: user_id,
        status: "Success"
      });

      if (response.data && response.data.response) {
        const payments = response.data.response;
        
        let found299 = false;
        let found5999 = false;

        payments.forEach(payment => {
          try {
            const details = typeof payment.details === 'string' ? JSON.parse(payment.details) : payment.details;
            if (details.amount_paid === 299) found299 = true;
            if (details.amount_paid === 5999) found5999 = true;
          } catch (e) {
            console.error("Error parsing payment details", e);
          }
        });

        setHasPurchased299(found299);
        setHasPurchased5999(found5999);
        localStorage.setItem(`has_purchased_299_${loggedInUser}`, found299.toString());
        localStorage.setItem(`has_purchased_5999_${loggedInUser}`, found5999.toString());
      }
    } catch (error) {
      console.error("Error checking payment history:", error);
    }
  };

  useEffect(() => {
    axios.post(`https://${baseUrl}/request`, {
      object: "crn",
      qdn: "diabrain",
    }).then((response) => {
      if (response.data && response.data.crn) {
        setCrn(response.data.crn);
      }
    }).catch((error) => {
      console.error("CRN fetch error:", error);
    });
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => {
      console.log("Razorpay SDK loaded successfully.");
    };
    script.onerror = () => {
      console.error("Razorpay SDK failed to load.");
    };
    document.body.appendChild(script);
  }, []);

  const uploadPDF = (pdfBlob, fileName, yymm) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `https://${baseUrl}/upload`, true);
      xhr.setRequestHeader("x-dt", yymm);
      xhr.setRequestHeader("x-name", fileName);
      xhr.setRequestHeader("x-enc", "bin");
      xhr.onload = () => {
        if (xhr.status === 200) resolve(xhr.responseText);
        else reject("Upload failed: " + xhr.statusText);
      };
      xhr.onerror = () => reject("Upload error");
      xhr.send(pdfBlob);
    });
  };

  const getCurrentDialCount = () => {
    const fromUserDetails = userDetails?.response?.[userDetails.response.length - 1]?.dial_cnt;
    const fromUserLocal = localStorage.getItem(`dial_cnt_${loggedInUser}`);
    const fromGenericLocal = localStorage.getItem("dial_cnt");

    const candidates = [fromUserDetails, fromUserLocal, fromGenericLocal]
      .map((value) => parseInt(value ?? "0", 10))
      .filter((value) => Number.isFinite(value) && value >= 0);

    return candidates.length ? Math.max(...candidates) : 0;
  };

  const handlePayment = async (plan, amount) => {
    try {
      if (!window.Razorpay) {
        alert("Razorpay SDK failed to load. Please try again.");
        return;
      }

      if (!crn) {
        alert("Please enter a valid CRN.");
        return;
      }

      const today = new Date();
      const formattedDateTime = today.getFullYear() + "-" +
        String(today.getMonth() + 1).padStart(2, "0") + "-" +
        String(today.getDate()).padStart(2, "0") + " " +
        String(today.getHours()).padStart(2, "0") + ":" +
        String(today.getMinutes()).padStart(2, "0") + ":" +
        String(today.getSeconds()).padStart(2, "0");

      let expiryDate = new Date(today);
      let formattedExpiryDate = "";

      const formatDateTime = (dateObj) => {
        return dateObj.getFullYear() + "-" +
          String(dateObj.getMonth() + 1).padStart(2, "0") + "-" +
          String(dateObj.getDate()).padStart(2, "0") + " " +
          String(dateObj.getHours()).padStart(2, "0") + ":" +
          String(dateObj.getMinutes()).padStart(2, "0") + ":" +
          String(dateObj.getSeconds()).padStart(2, "0");
      };

      const parseDateTimeToMs = (dateStr) => {
        if (!dateStr) return 0;
        const parts = dateStr.split(/[- :]/);
        if (parts.length >= 6) {
          return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
        }
        if (parts.length === 3) {
          return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime();
        }
        return 0;
      };

      if (plan === "Testing Plan (2 Mins)") {
        expiryDate.setMinutes(expiryDate.getMinutes() + 2);
        formattedExpiryDate = formatDateTime(expiryDate);
      } else if (plan === "Topup 25 Credits" || amount === 299) {
        expiryDate.setDate(expiryDate.getDate() + 30);
        formattedExpiryDate = formatDateTime(expiryDate);
      } else if (plan === "Topup 50 Credits" || plan === "Topup 100 Credits" || plan === "1 Year Access") {
        const storedExpiry = localStorage.getItem("expiry_date");
        const storedExpiryMs = parseDateTimeToMs(storedExpiry);
        const nowMs = today.getTime();
        const activeBalance = parseInt(currentRemainingBalance ?? "0", 10);
        const hasActiveTime = storedExpiry && storedExpiry !== "0" && storedExpiryMs > nowMs;
        const hasActiveCalculationBalance = Number.isFinite(activeBalance) && activeBalance > 0;

        if (hasActiveTime && hasActiveCalculationBalance) {
          formattedExpiryDate = storedExpiry;
        } else {
          expiryDate.setFullYear(expiryDate.getFullYear() + 1);
          formattedExpiryDate = formatDateTime(expiryDate);
        }
      } else {
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        formattedExpiryDate = formatDateTime(expiryDate);
      }

      const user_id = localStorage.getItem("user_id");
      const email = localStorage.getItem("email");
      const user_name = localStorage.getItem("username");

      const payload = { vendor: "Razorpay", amount: amount };
      const orderResponse = await axios.post(`https://${baseUrl}/create-order`, payload);

      if (orderResponse.data.status !== "00") {
        alert("Couldn't process payment. Please try again.");
        return;
      }

      const options = {
        key: orderResponse.data.apik,
        amount: amount,
        currency: "INR",
        name: "DiabWellness Private Limited",
        description: "DiaBrain Decision Support Service",
        image: "https://diax.ai/assets/Group%203.png",
        order_id: orderResponse.data.details.id,
        handler: async (paymentResponse) => {
          try {
            const verifyPayload = {
              payment_id: paymentResponse.razorpay_payment_id,
              order_id: paymentResponse.razorpay_order_id,
              signature: paymentResponse.razorpay_signature,
            };

            const verifyResponse = await axios.post(`https://${baseUrl}/verify-signature`, verifyPayload);

            if (verifyResponse.data.status !== "00") {
              alert("Payment verification failed. Please retry.");
              return;
            }

            const currentDialCountAtPurchase = getCurrentDialCount();

            const paymentData = {
              action: "A",
              object: "payments",
              user_id: user_id,
              user_name: user_name,
              reason: "DiaBrain Decision Support",
              crn: crn,
              order_id: `${paymentResponse.razorpay_order_id}|${paymentResponse.razorpay_payment_id}`,
              status: "Success",
              details: JSON.stringify({
                payment_info: verifyResponse.data,
                hospital: "DiaBrain",
                plan: plan,
                amount_paid: amount,
                expiry_date: formattedExpiryDate,
                order_date: formattedDateTime,
                start_dial_cnt: currentDialCountAtPurchase,
                usage_start_count: currentDialCountAtPurchase,
                dial_cnt_at_purchase: currentDialCountAtPurchase,
              }),
            };
            await axios.post(`https://${baseUrl}/request`, paymentData);

            await refreshPayments();

            const formattedExpiryMs = parseDateTimeToMs(formattedExpiryDate);
            localStorage.setItem("isSubscribed", "true");
            localStorage.setItem("amount_paid", amount);
            localStorage.setItem("expiry_date", formattedExpiryDate);
            localStorage.setItem("expiry_timestamp", formattedExpiryMs.toString());
            localStorage.setItem("order_date", formattedDateTime);
            localStorage.setItem(`active_usage_baseline_${loggedInUser}`, currentDialCountAtPurchase.toString());
            
            // Update purchase history states specifically
            if (amount === 299) {
              setHasPurchased299(true);
              localStorage.setItem(`has_purchased_299_${loggedInUser}`, "true");
            }
            if (amount === 5999) {
              setHasPurchased5999(true);
              localStorage.setItem(`has_purchased_5999_${loggedInUser}`, "true");
            }

            if (onPaymentSuccess) await onPaymentSuccess();

            alert("Payment successful! Subscription/Topup is active.");

            const billsave = {
              action: "A",
              object: "bill",
              bill_type: "Invoice",
              bill_class: "DiaBrain Decision Support",
              user_id: user_id,
              user_name: user_name,
              total: amount,
              crn: parseInt(crn),
              bill_det: JSON.stringify({
                Item: `DiaBrain Decision Support ${plan} - Expiry ${formattedExpiryDate}`,
                amount: amount,
                quantity: "1",
              }),
            };
            const saveResponse = await axios.post(`https://${baseUrl}/request`, billsave);
            const bill_num = saveResponse.data.bill_num;
            console.log("bill", bill_num);
            if (!bill_num) throw new Error("Bill number not returned");

            const doc = new jsPDF();
            doc.setFontSize(22);
            doc.text("INVOICE", 80, 15);
            doc.setFontSize(12);
            doc.text(`Invoice No: ${bill_num}`, 14, 30);
            doc.text(`Date: ${formattedDateTime}`, 14, 40);
            doc.text(`User Name: ${user_name}`, 14, 50);
            doc.text(`Company Name: DIABWELLNESS PRIVATE LIMITED`, 14, 60);
            doc.text(`Address: NO 9 RAMASAMY KOIL WEST STREET, Kumbakonam, Tamil Nadu, India - 612001`, 14, 70);

            const headers = [["Item", "Qty", "Base Price", "GST (18%)", "Total"]];
            const basePrice = amount / 1.18;
            const gstValue = amount - basePrice;
            const data = [[
              `DiaBrain Decision Supports ${plan} - Expiry ${formattedExpiryDate}`,
              "1",
              `Rs.${basePrice.toFixed(2)}`,
              `Rs.${gstValue.toFixed(2)}`,
              `Rs.${amount.toFixed(2)}`,
            ]];

            autoTable(doc, {
              startY: 80,
              head: headers,
              body: data,
              theme: "grid",
              styles: { fontSize: 10, cellPadding: 3 },
              headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
              bodyStyles: { fontStyle: "bold" },
            });

            doc.text("** This is a system-generated invoice and does not require a signature **", 35, doc.lastAutoTable.finalY + 10);

            const pdfBlob = doc.output("blob");
            const nowmm = new Date().getMonth() + 1;
            const yymm = `${new Date().getFullYear()}${nowmm < 10 ? "0" + nowmm : nowmm}`;
            const fileName = `${user_id}_Invoice_${today.getTime()}.pdf`;

            await uploadPDF(pdfBlob, fileName, yymm);

            await axios.post(`https://${baseUrl}/request`, {
              action: "A",
              object: "repos",
              crn,
              user: user_id,
              rep_type: "Invoice",
              name: fileName,
              udt: today.toISOString().split("T")[0],
              mode: "Upload",
              internal_name: fileName,
              yyyymm: yymm,
              status: "N",
              last_update_user: user_id,
              external_name: `https://${baseUrl}/docs/${yymm}/${fileName}`,
            });

            alert("Payment successful & Invoice uploaded!");
            Navigate("/invoice");
          } catch (error) {
            console.error("Error verifying payment:", error);
            alert("Payment verification failed. Please contact support.");
          }
        },
        prefill: {
          name: user_name,
          email: email,
          contact: user_id,
        },
        theme: { color: "#F37254" },
      };

      const rzp1 = new window.Razorpay(options);
      rzp1.open();
    } catch (error) {
      console.error("Error processing payment:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Select a Payment Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }} className="mb-4">
          Please subscribe or top-up your credits to continue using this feature.
        </p>

        <Row className="text-center justify-content-center">

          {/* ₹299 PLAN (Only shown if user has NOT bought 299 and NOT bought 5999) */}
          {show299 && (
            <Col md={show5999 ? 5 : 6} className="mb-3">
              <Card className="shadow p-3 h-100">
                <Card.Body className="d-flex flex-column">
                  <h5 className="text-info">Topup Plan</h5>
                  <h3>₹299</h3>
                  <p>30 Days Validity</p>
                  <p className="text-warning fw-bold">25 Credits</p>
                  <div className="mt-auto">
                    <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 25 Credits", 299)}>
                      Proceed to Pay
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
          
          {/* ₹5,999 PLAN (Shown initially, and shown alone if user previously bought 299) */}
          {show5999 && (
            <Col md={show299 ? 5 : 6} className="mb-3">
              <Card className="shadow p-3 h-100 border-primary">
                <Card.Body className="d-flex flex-column">
                  <h5 className="text-primary">1 Year Access</h5>
                  <h3>₹5,999</h3>
                  <p>365 Days Validity</p>
                  <p className="text-warning fw-bold">100 Credits</p>
                  <div className="mt-auto">
                    <Button variant="success" className="w-100" onClick={() => handlePayment("1 Year Access", 5999)}>
                      Proceed to Pay
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* ₹2,499 & ₹4,499 PLANS (ONLY shown if user has successfully purchased 5999 previously) */}
          {showTopups && (
            <>
              <Col md={5} className="mb-3">
                <Card className="shadow p-3 h-100">
                  <Card.Body className="d-flex flex-column">
                    <h5 className="text-info">Topup Plan</h5>
                    <h3>₹2,499</h3>
                    <p>365 Days Validity</p>
                    <p className="text-warning fw-bold">50 Credits</p>
                    <div className="mt-auto">
                      <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 50 Credits", 2499)}>
                        Proceed to Pay
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={5} className="mb-3">
                <Card className="shadow p-3 h-100">
                  <Card.Body className="d-flex flex-column">
                    <h5 className="text-danger">Topup Plan</h5>
                    <h3>₹4,499</h3>
                    <p>365 Days Validity</p>
                    <p className="text-warning fw-bold">100 Credits</p>
                    <div className="mt-auto">
                      <Button variant="success" className="w-100" onClick={() => handlePayment("Topup 100 Credits", 4499)}>
                        Proceed to Pay
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </>
          )}

        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default Payment;